<template>
  <section class="p-3">
    <v-container
      class="p-3 mt-2 d-flex flex-column flex-sm-row justify-content-between"
    >
      <h2 class="ml-1 my-2">
        Mis Solicitudes
      </h2>
      <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
    </v-container>
    <v-tabs
      fixed-tabs
      centered
      v-model="tab"
      active-class="bg-primary"
      class="px-16 custom-multiline-tabs"
    >
      <v-tab
        key="sm"
        active-class="bg-app-primary text-white rounded"
        class="tab-list pb-2"
        >Solicitudes de Material</v-tab
      >
      <v-tab
        key="soc"
        active-class="bg-app-primary text-white rounded"
        class="tab-list pb-2"
        >Solicitudes de Orden de Compra</v-tab
      >
      <v-tab
        key="hes"
        active-class="bg-app-primary text-white rounded"
        class="tab-list pb-2"
        >HES</v-tab
      >

      <v-tab
        class="tab-list"
        active-class="bg-app-primary text-white rounded"
        key="quotes"
        >Solicitudes de Cotización</v-tab
      >
      <v-tab
        class="tab-list"
        active-class="bg-app-primary text-white rounded"
        key="suppliers"
        >Solicitudes de Proveedor</v-tab
      >
      <v-tab
        class="tab-list"
        active-class="bg-app-primary text-white rounded"
        key="products"
        >Solicitudes de Producto</v-tab
      >
      <v-tab
        v-if="cubicadorV2Enabled"
        class="tab-list"
        active-class="bg-app-primary text-white rounded"
        key="cubicador"
        >Reservas Cubicador</v-tab
      >
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="sm">
        <request-materials
          :showHeader="false"
          class="mt-4"
          title="Mis Solicitudes"
          :filter-by-user="true"
          @requestMaterialsCreated="getRequestMaterials"
          ref="request-materials"
          :stockItemGroup="false"
        ></request-materials>
      </v-tab-item>
      <v-tab-item key="soc">
        <section class="py-5">
          <request-services
            :showHeader="false"
            ref="requestServices"
            title="Solicitar Orden de Compra"
            :requestingUserModule="true"
            :requestPurchaseOrder="true"
          >
          </request-services>
        </section>
      </v-tab-item>
      <v-tab-item key="hes">
        <list-hes :showHeader="false"> </list-hes>
      </v-tab-item>
      <v-tab-item key="quotes">
        <list-quotes
          :showHeader="false"
          ref="requestQuotes"
          :requestingUserModule="true"
        >
        </list-quotes>
      </v-tab-item>
      <v-tab-item key="suppliers">
        <list-suppliers
          :showHeader="false"
          ref="requestSuppliers"
          :showActionCreate="false"
        >
        </list-suppliers>
      </v-tab-item>
      <v-tab-item key="products">
        <list-products
          :showHeader="false"
          ref="requestProducts"
          :showActionCreate="false"
        >
        </list-products>
      </v-tab-item>
      <v-tab-item v-if="cubicadorV2Enabled" key="cubicador">
        <section class="py-5">
          <cubicador-bundles-table mode="mine"></cubicador-bundles-table>
        </section>
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<script>
import RequestMaterials from "../../requestMaterials/index.vue";
import RequestServices from "../../requestServices/quotes/index.vue";
import { authUsuarioComputed } from "@/state/helpers";
import ListQuotes from "../../requestServices/quotes/ListQuotes.vue";
import ListSuppliers from "../../supplying/formSuppliers/index.vue";
import ListProducts from "../../supplying/formMaterials/index.vue";
import PurchaseOrders from "../../supplying/purchaseModule/purchaseRequests/index.vue";
import ListHes from "../../supplying/ocWithHes/index.vue";
import CubicadorBundlesTable from "@/components/commons/CubicadorBundlesTable.vue";
import config from "@/config";
export default {
  data() {
    return {
      tab: "sm",
      breadcrumb: [
        {
          text: "Proyectos",
          disabled: false,
          href: "/",
        },
        {
          text: "Mis Solicitudes",
          disabled: true,
          href: "/my-request-materials",
        },
      ],
      cubicadorV2Enabled: config.cubicador_v2,
    };
  },
  components: {
    RequestMaterials,
    RequestServices,
    ListQuotes,
    ListSuppliers,
    ListProducts,
    PurchaseOrders,
    ListHes,
    CubicadorBundlesTable,
  },
  mounted() {
    // ?tab=cubicador (e.g. from the cubicación's "Ver solicitudes pendientes") opens the
    // Reservas Cubicador tab, the last one when the v2 flag is on
    if (this.cubicadorV2Enabled && this.$route.query.tab === "cubicador") {
      this.$nextTick(() => {
        this.tab = this.$el.querySelectorAll(".v-tab").length - 1;
      });
    }
  },
  methods: {
    async getRequestMaterials() {
      this.$refs["request-materials"].getRequestMaterialsData(1);
    },
  },
  computed: {
    ...authUsuarioComputed,
  },
};
</script>

<style scoped>
/* Accedemos al contenedor interno de Vuetify */
::v-deep .v-slide-group__content {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr);
  /* Agregamos espacio entre filas y columnas */
  row-gap: 12px; /* Espacio vertical entre la fila 1 y 2 */
  column-gap: 8px; /* Espacio horizontal entre botones */
}

/* Ajuste opcional para la altura del componente */
::v-deep .v-tabs-bar {
  height: auto !important; /* Permite que el contenedor crezca según el contenido */
  padding: 10px 0; /* Añade aire arriba y abajo */
}

::v-deep .v-tab {
  max-width: none !important;
  width: 100%;
  /* Si los tabs se ven muy altos, puedes definir un height fijo aquí */
  height: 48px !important;
}

/* Oculta el slider (la línea azul) por completo */
::v-deep .v-tabs-slider-wrapper {
  display: none !important;
}
</style>
